import React, {Dispatch, SetStateAction, useState} from 'react';
import {FormOperacionCapitalMarketsDetalle, schemaFormOperacionCapitalMarketsDetalle} from "../types/types";
import {useConfirmationDialog} from "../../../../../hooks/useConfirmationDialog";
import {Alert, Box, Button, Card, CardContent, IconButton, Stack, Tooltip} from "@mui/material";
import {ICON_MAS} from "../../../components/SharedIcons";
import CardActions from "../../../components/CardActions";
import {useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod/dist/zod";
import {EntityWithIdFields} from "src/lib/itaptec/http_client/src";
import DeleteIcon from "@mui/icons-material/Delete";
import CapitalMarketsDetalleDialog from "./CapitalMarketsDetalleDialog";
import CapitalMarketsDetalle from "./CapitalMarketsDetalle";

interface SeccionCapitalMarketDetalleNuevoProps {
  codPais: number
  detalleProvisional?: FormOperacionCapitalMarketsDetalle
  setDetalleProvisional: Dispatch<SetStateAction<FormOperacionCapitalMarketsDetalle | undefined>>;
}


function SeccionCapitalMarketsDetalleNuevo({
                                             codPais,
                                             detalleProvisional,
                                             setDetalleProvisional
                                           }: SeccionCapitalMarketDetalleNuevoProps) {
  const {askConfirmation} = useConfirmationDialog()

  const [openDialog, setOpenDialog] = useState<boolean>(false)

  const formMethods = useForm<FormOperacionCapitalMarketsDetalle>({
    resolver: zodResolver(schemaFormOperacionCapitalMarketsDetalle),
    defaultValues: {
      [EntityWithIdFields.Id]: -1,

    }
  })

  const {control, handleSubmit, reset} = formMethods

  const alGuardarDetalleProvisional = (data: FormOperacionCapitalMarketsDetalle) => {
    setDetalleProvisional(data)
    reset()
    setOpenDialog(false)
  }

  return (
    <CardActions
      title={'Detalle'}
      actions={
        <Button variant='contained' color='primary' endIcon={ICON_MAS} onClick={() => setOpenDialog(true)}>
          Nuevo
        </Button>
      }
      colapsable
    >
      {
        !detalleProvisional ?
          (
            <Alert severity='info'>No se encontró detalle para esta operación.</Alert>
          ) :
          <Stack>
            <Card key={detalleProvisional.id}>
              <Box display='flex' justifyContent='flex-end'>
                <Tooltip title='Eliminar'>
                  <IconButton
                    onClick={() =>
                      askConfirmation(() =>
                        setDetalleProvisional(undefined as unknown as FormOperacionCapitalMarketsDetalle)
                      )
                    }
                  >
                    <DeleteIcon color='error'/>
                  </IconButton>
                </Tooltip>
              </Box>
              <CardContent>
                <CapitalMarketsDetalle detalle={detalleProvisional}/>
              </CardContent>
            </Card>

          </Stack>
      }

      <CapitalMarketsDetalleDialog
        codPais={codPais}
        formMethods={formMethods} onSubmitForm={alGuardarDetalleProvisional} onClose={() => setOpenDialog(false)}
        open={openDialog}/>

    </CardActions>
  );
}

export default SeccionCapitalMarketsDetalleNuevo;